var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorreo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 154.33,
    height: 105.01,
    viewBox: "0 0 154.33 105.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_4530",
    x: 0,
    y: 0,
    width: 154.33,
    height: 105.01,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trazado_4530)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4530-2",
    "data-name": "Trazado 4530",
    d: "M127.671,0h-113A14.686,14.686,0,0,0,0,14.67V78.34A14.692,14.692,0,0,0,14.671,93.01h113A14.69,14.69,0,0,0,142.33,78.34V14.67A14.683,14.683,0,0,0,127.671,0m-4.5,62a6.5,6.5,0,0,1-8.661,9.689L95.08,54.33,75.33,71.72a6.511,6.511,0,0,1-8.631-.031L47.609,54.64l-19.4,17.08a6.5,6.5,0,1,1-8.594-9.76L37.85,45.92,19.58,29.6a6.5,6.5,0,0,1,8.66-9.7L51.921,41.06a1.108,1.108,0,0,1,.159.139l18.981,16.96L90.65,40.909l.3-.26,23.6-20.779a6.5,6.5,0,0,1,8.59,9.76L104.91,45.68Z",
    transform: "translate(6 3)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/Correo.becb261a19af567aea8f5c5535cd545a.svg";
export { ForwardRef as ReactComponent };